/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};



/******/ })()
;
// function toggleAccordion(element) {
//   const header = element;
//   const content = header.nextElementSibling;
//   const allContents = document.querySelectorAll('.accordion-content');
//   const allHeaders = document.querySelectorAll('.accordion-header');

//   allContents.forEach((item) => {
//     if (item !== content) {
//       item.style.display = 'none';
//     }
//   });

//   allHeaders.forEach((item) => {
//     if (item !== header) {
//       item.classList.remove('active');
//     }
//   });

//   if (content.style.display === 'block') {
//     content.style.display = 'none';
//     header.classList.remove('active');
//   } else {
//     content.style.display = 'block';
//     header.classList.add('active');
//   }
// }

// function showTable(unit) {
//   const cmTable = document.getElementById('size-chart-cm');
//   const inchesTable = document.getElementById('size-chart-inches');
//   if (unit === 'cm') {
//     cmTable.style.display = 'table';
//     inchesTable.style.display = 'none';
//   } else {
//     cmTable.style.display = 'none';
//     inchesTable.style.display = 'table';
//   }
// }

// function showTable(unit) {
//   const cmBtn = document.getElementById('cm-btn');
//   const inchesBtn = document.getElementById('inches-btn');
//   const cmTable = document.getElementById('size-chart-cm');
//   const inchesTable = document.getElementById('size-chart-inches');

//   if (unit === 'cm') {
//     cmTable.style.display = 'table';
//     inchesTable.style.display = 'none';
//     cmBtn.classList.add('active');
//     inchesBtn.classList.remove('active');
//   } else {
//     cmTable.style.display = 'none';
//     inchesTable.style.display = 'table';
//     cmBtn.classList.remove('active');
//     inchesBtn.classList.add('active');
//   }
// }
function toggleAccordion(element) {
  const header = element;
  const content = header.nextElementSibling;
  const allContents = document.querySelectorAll('.accordion-content');
  const allHeaders = document.querySelectorAll('.accordion-header');

  allContents.forEach((item) => {
    if (item !== content) {
      item.style.display = 'none';
    }
  });

  allHeaders.forEach((item) => {
    if (item !== header) {
      item.classList.remove('active');
    }
  });

  if (content.style.display === 'block') {
    content.style.display = 'none';
    header.classList.remove('active');
  } else {
    content.style.display = 'block';
    header.classList.add('active');
  }
}

function showTable(unit) {
  const cmBtn = document.getElementById('cm-btn');
  const inchesBtn = document.getElementById('inches-btn');
  const cmTables = document.querySelectorAll('.size-chart-cm');
  const inchesTables = document.querySelectorAll('.size-chart-inches');

  if (unit === 'cm') {
    cmTables.forEach(table => table.style.display = 'table');
    inchesTables.forEach(table => table.style.display = 'none');
    cmBtn.classList.add('active');
    inchesBtn.classList.remove('active');
  } else {
    cmTables.forEach(table => table.style.display = 'none');
    inchesTables.forEach(table => table.style.display = 'table');
    cmBtn.classList.remove('active');
    inchesBtn.classList.add('active');
  }
}





